import { DUTY_ANALYTICS_COPY } from '../copy';

/**
 * What a section the server could not compute says instead of its figures — one sentence, never zeros
 * and never a blank card. `components/ReportSection.tsx` says why there is no retry beside it.
 */
export const SectionFailure = () => (
  <p className="text-sm text-muted-foreground" data-testid="section-failure">
    {DUTY_ANALYTICS_COPY.sectionFailure}
  </p>
);
